"use client";

import Link from "next/link";
import { ReactNode, useEffect } from "react";
import { webAssetsCdnBaseUrl } from "./constants";
import { classNames } from "@/helpers/tailwind-class";

interface HeaderProps {
  left: ReactNode;
  middle: ReactNode;
  right: ReactNode;
  staticStyle?: boolean;
}

export function HeaderLogoWithName() {
  return (
    <Link className="flex shrink-0 items-center" href="/">
      <HeaderLogo />
      <div className="mx-2 pb-[2px] text-sm font-bold text-neutral-50 sm:text-xl">Magic Hour</div>
    </Link>
  );
}

export function HeaderLogo() {
  return (
    <img height={34} width={34} src={`${webAssetsCdnBaseUrl}/logo.svg`} alt="Magic Hour Logo" />
  );
}
